export default {"src":"/_next/static/media/Logo_gases_guajira_full.bd8cb238.svg","height":2351,"width":5494,"blurWidth":0,"blurHeight":0};